<template>
    <div>
        <el-select
            v-if="mode == 'edit'"
            :placeholder="placeholder"
            :value="value"
            @change="update"
            :filterable="filterable"
            :disabled="disabled"
            class="wp-10"
            :data-bot="dataBot"
            :popper-append-to-body="appendToBody"
            popper-class="custom-dropdown"
        >
            <el-option v-if="selectNothing" :label="selectNothing" :value="null" />
            <el-option
                v-for="option in options"
                :key="option[idColumn]"
                :label="option[labelColumn]"
                :value="option[idColumn]"
                :disabled="!!option.disabled"
            >
                <slot :option="option">{{ option[labelColumn] }}</slot>
            </el-option>
        </el-select>
        <p v-else>
            {{ labelFromValue }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        value: {
            type: [Number, String],
            required: false,
            default: '',
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        labelColumn: {
            type: String,
            required: false,
            default: 'label',
        },
        idColumn: {
            type: String,
            required: false,
            default: 'value',
        },
        filterable: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        selectNothing: {
            type: [String, Boolean],
            required: false,
            default: false,
        },
        appendToBody: {
            type: Boolean,
            default: false,
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {};
    },
    computed: {
        labelFromValue() {
            return this.options.find((option) => option[this.idColumn] == this.value)[
                this.labelColumn
            ];
        },
    },
    methods: {
        update(newValue) {
            this.$emit('input', newValue);
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.el-select-dropdown.el-popper.custom-dropdown {
    box-shadow: 0 0 12px rgba(17, 17, 17, 0.24);
    border-radius: 6px;
    margin-top: 4px;
    .popper__arrow {
        display: none;
    }
    .el-select-dropdown__list {
        padding: 8px 0;
        .el-select-dropdown__item {
            border-radius: 4px;
            margin: 0 8px;
            padding: 0 8px;
        }
    }
}
</style>
